import { useState } from "react";
import pixelBuilding from "../assets/pixel/hero-building.gif";

// Image with a fallback when the URL is missing or fails to load: a small pixel-art scene.
export default function SmartImage({ src, alt, className = "", placeholder = "Fotografija uskoro", art = pixelBuilding, ...rest }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`photo-placeholder ${className}`} role="img" aria-label={alt}>
        <img src={art} alt="" className="pixel" loading="lazy" />
        <span>{placeholder}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
